/*
 *
 * ----------------------------------------------- */
// jQuery Simulation
jQuery(function ($) {
  // $("select option:first-child").text("選択してください");
  // $("select option:first-child").attr("disabled", "disabled");
  // var select = $("select");
  // select.append("body");
});

$("select").on("change", function () {
  $(this).addClass("havcolor");
});

$(".page-simulation-form select[name=area] option:first").attr(
  "disabled",
  "disabled"
);
